import { ChevronUpIcon } from '@heroicons/react/16/solid';

/**
 * Home page FAQ.
 *
 * Native <details>/<summary> rather than a headless component library. Each
 * item opens and closes independently, which is what a set of <details> with no
 * shared `name` does by default, and the browser supplies the whole interaction
 * for free: aria-expanded, Enter and Space, focus order, and find-in-page
 * reaching text inside a closed panel.
 *
 * It also renders correctly with no JavaScript at all -- and, unlike the
 * unmounted panels this replaces, the answers are present in the prerendered
 * HTML, so a crawler reads all five.
 */

const faqs = [
  {
    question: 'Who runs Butter Websites?',
    answer:
      'Butter Websites is a two-person team from Cincinnati, Ohio. Both graduated from Miami University in 2015. Taylor is a web developer with more than a decade of professional experience building software products at Fortune 500 companies, award-winning agencies, and startups. Kate is an accountant, data automation specialist, and spreadsheet wizard, previously employed at Deloitte and T-Mobile US.',
  },
  {
    question: 'Am I locked into a contract?',
    answer:
      "There's a 12-month minimum to start, and after that we earn your business month-to-month. If our partnership is not a good fit, let us know, and we'll part on good terms.",
  },
  {
    question: 'Do I own my website?',
    answer:
      'Yes. Once you are completely satisfied with your website, we transfer ownership to your Shopify account and you own it 100%.',
  },
  {
    question: 'Do you build non-Shopify websites?',
    answer:
      'No. We believe that Shopify is the best-in-class merchant platform, and we exclusively build on it.',
  },
  {
    question: 'Do I have to use Shopify POS?',
    answer:
      'No. Though we strongly recommend it, the entire suite of Shopify’s retail tools is optional. If you’re already happy with your current point-of-sale system, you can keep using it. If not, you’re welcome to add Shopify POS now or later; we’ll help you connect it if you ever need it.',
  },
];

export default function FAQ() {
  return (
    <div className="mx-auto mt-10 w-full max-w-[860px]">
      {faqs.map((faq, i) => (
        // overflow-hidden lets the card's own 20px radius clip the trigger,
        // instead of the trigger carrying an off-scale 18px radius of its
        // own. 18px is not on the design system's radius scale.
        <details
          key={faq.question}
          className={`group overflow-hidden rounded-[20px] border-2 border-bw-ink bg-white shadow-sticker ${
            i === 0 ? '' : 'mt-4'
          }`}
        >
          {/* Selected state is a yellow fill, per the design system.
              list-none plus the webkit rule removes the default disclosure
              triangle in every engine -- Safari still draws it through the
              -webkit marker pseudo-element rather than `display: list-item`. */}
          <summary className="flex w-full cursor-pointer list-none items-center justify-between gap-4 bg-white px-6 py-5 text-left font-display text-[17px] font-bold text-bw-ink hover:bg-yellow-soft focus:outline-none focus-visible:ring-[3px] focus-visible:ring-inset focus-visible:ring-bw-ink group-open:bg-bw-yellow [&::-webkit-details-marker]:hidden">
            <span>{faq.question}</span>
            <ChevronUpIcon
              aria-hidden="true"
              className="h-6 w-6 shrink-0 text-bw-ink transition-transform duration-200 group-open:rotate-180"
            />
          </summary>
          <div className="border-t-2 border-bw-ink px-6 py-5 text-left text-[17px] leading-[1.6] text-ink-700">
            {faq.answer}
          </div>
        </details>
      ))}
    </div>
  );
}
